// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__26UkL","imageUploader":"EGiftCard_imageUploader__JOJt-"};